<template>
  <div class="page-wrapper">
    <div :class="['header-wrap style1', { sticky: isSticky }]">
      <div class="header-top">
        <div class="container">
          <TopHeader />
        </div>
      </div>
      <MainNavbarPages />
    </div>

    <div class="content-wrapper">
      <!-- <PageBanner pageTitle="Service Details" mainTitle="Service Details" /> -->
      <div class="service-details-wrap ptb-50">
        <div class="container">
          <div class="row">
            <div class="col-xl-4 col-lg-12 order-xl-1 order-lg-2 order-md-2 order-2">
              <SideBar />
            </div>

            <div class="col-xl-8 col-lg-12 order-xl-2 order-lg-1 order-md-1 order-1">
              <div class="service-desc">


                <div class="row">
                  <div class="col-md-9">
                    <h2>Dr. Gina Neculăeș – Medic specialist endocrinolog</h2>
                    <div class="other-option md-none mt-40">
                      <a href="/#appointment" class="btn style2">
                        Solicită o programare
                      </a>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="team-card style3">
                      <div class="team-img"> <img src="../../../assets/images/doctors/dr-gina-neculaes-1.jpg"
                          alt="Dr. Gina Neculăeș – Endocrinologie" /></div>
                    </div>
                  </div>
                </div>

                <p>
                  Sunt <strong>Dr. Gina Neculăeș</strong>, medic specialist endocrinolog.
                  Practic endocrinologia cu pasiune și responsabilitate, având convingerea
                  că fiecare pacient merită să fie ascultat, înțeles și ghidat corect.
                </p>
                <p>
                  Sunt permanent conectată la ghidurile și recomandările medicale actuale,
                  pentru a oferi soluții moderne, sigure și personalizate. În cabinet,
                  profesionalismul se îmbină cu empatia, iar obiectivul meu este să
                  construim împreună un parcurs clar către echilibru hormonal și o stare
                  de sănătate durabilă.
                </p>

                <ul class="content-feature-list style5 list-style">
                  <li>
                    <i class="ri-check-double-line"></i>Diagnostic și management al afecțiunilor endocrine
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Patologie tiroidiană și boli metabolice
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Sindromul ovarelor polichistice (PCOS)
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Ecografie tiroidiană
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Evaluare osteodensitometrică BMD DXA
                  </li>
                </ul>

                <h3>Educație și formare profesională</h3>
                <p>
                  Pregătirea profesională este fundamentul practicii medicale moderne,
                  motiv pentru care formarea continuă ocupă un rol esențial în activitatea
                  mea medicală.
                </p>

                <ul class="content-feature-list style5 list-style">
                  <li>
                    <i class="ri-check-double-line"></i>
                    2018 – 2025 – Rezidențiat în Endocrinologie, Clinica de Endocrinologie,
                    Spitalul „Sf. Spiridon”, Iași
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>
                    2011 – 2017 – Facultatea de Medicină Generală, UMF „Gr. T. Popa”, Iași
                  </li>
                </ul>

                <h3>Experiență profesională</h3>
                <p>
                  Experiența clinică este orientată către diagnosticarea și monitorizarea
                  afecțiunilor endocrine complexe, cu abordare interdisciplinară atunci
                  când este necesar.
                </p>

                <ul class="content-feature-list style5 list-style">
                  <li>
                    <i class="ri-check-double-line"></i>
                    Medic rezident endocrinolog (2018 – 2025)
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>
                    Managementul patologiei tiroidiene și metabolice
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>
                    Colaborare interdisciplinară cu alte specialități medicale
                  </li>
                </ul>


              </div>
            </div>




          </div>
        </div>
      </div>


    </div>
    <MainFooter />
  </div>
</template>

<script>
import TopHeader from "../../Layouts/TopHeader.vue";
import MainNavbarPages from "../../Layouts/MainNavbarPages.vue";
import SideBar from "./SideBar.vue";
// import ServiceDetails from "../../ServiceDetails/ServiceDetails.vue";
import MainFooter from "../../Layouts/MainFooter.vue";

import { defineComponent } from "vue";

export default defineComponent({
  name: "GinaNeculaesPage",
  components: {
    TopHeader,
    SideBar,
    MainNavbarPages,
    // ServiceDetails,
    MainFooter,
  },
  data() {
    return {
      isSticky: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", () => {
      let scrollPos = window.scrollY;
      if (scrollPos >= 100) {
        this.isSticky = true;
      } else {
        this.isSticky = false;
      }
    });
  },
});
</script>